import React, { Component } from "react";
import OutfitListView from "presentational/common/outfitUnit/OutfitListView";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

class LoungeSearchListPanel extends Component {
  static propTypes = {
    outfitList: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isEnd: PropTypes.bool.isRequired
  };

  render() {
    const { isLoading, isEnd, outfitList } = this.props;

    return (
      <div>
        <OutfitListView
          list={outfitList}
          isLoading={isLoading}
          isEnd={isEnd}
          callNextListFn={() => {}}
          emptyListText={<TXT name="msg_emptyListSearch" />}
          shortBottomPadding
          displayTooltipForGuest
        />
      </div>
    );
  }
}

export default LoungeSearchListPanel;
